import React from "react";

const Imegesnotfound = () => (
  <div>
    <h2>No Images Found</h2>
    <p>Please try a different search term</p>
  </div>
);

export default Imegesnotfound;
